import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import Modal from '../../../common/modal/Modal';
import EndPreventiveTaskResourceForm from './EndPreventiveTaskResourceForm';

import {
  getPreventiveTask,
  putDeactivatePreventiveTaskResource,
} from '../../../../actions/task-schedule/PreventiveTask';

export const EndPreventiveTaskResourceButton = ({
  preventiveTask,
  dispatchPutDeactivatePreventiveTaskResource,
  dispatchGetPreventiveTask,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const {
    companyResourceOptions: processedCompanyResourceOptions,
    companyResourceGroupOptions: processedCompanyResourceGroupOptions,
  } = useMemo(() => {
    const list = preventiveTask.preventiveTaskResourceList || [];

    const activeList = list.filter((item) => item.active !== false);

    const companyResourceOptions = activeList
      .filter((item) => item.companyResource)
      .map((item) => ({
        value: item.companyResource.id,
        label:
          item.companyResource.name || `Recurso #${item.companyResource.id}`,
      }));

    const companyResourceGroupOptions = Array.from(
      new Map(
        activeList
          .filter((item) => item.companyResourceGroup)
          .map((item) => [
            item.companyResourceGroup.id,
            {
              value: item.companyResourceGroup.id,
              label: item.companyResourceGroup.name,
            },
          ]),
      ).values(),
    );

    return {
      companyResourceOptions,
      companyResourceGroupOptions,
    };
  }, [preventiveTask]);

  const onModalSubmit = async (formValues) => {
    const payload = {
      companyResourceIdList: [],
      companyResourceGroupIdList: [],
    };

    if (
      formValues.companyResourceId &&
      formValues.companyResourceId.length > 0
    ) {
      payload.companyResourceIdList = formValues.companyResourceId.map(
        (option) => option.value,
      );
    }

    if (
      formValues.companyResourceGroupId &&
      formValues.companyResourceGroupId.length > 0
    ) {
      payload.companyResourceGroupIdList =
        formValues.companyResourceGroupId.map((option) => option.value);
    }

    await dispatchPutDeactivatePreventiveTaskResource(
      preventiveTask.id,
      payload,
    );

    dispatchGetPreventiveTask({
      preventiveTaskId: preventiveTask.id,
    });

    setShowModal(false);
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onShowModal = () => {
    const newModalBody = (
      <EndPreventiveTaskResourceForm
        onCancel={onCancel}
        handleProcess={onModalSubmit}
        companyResourceOptions={processedCompanyResourceOptions}
        companyResourceGroupOptions={processedCompanyResourceGroupOptions}
      />
    );

    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="warning" onClick={onShowModal}>
        <i className="fa fa-check-circle" /> Desactivar Recursos
      </Button>

      <Modal
        show={showModal}
        title="Desactivar Recursos de la Tarea Preventiva"
        body={modalBody}
        size="lg"
      />
    </>
  );
};

EndPreventiveTaskResourceButton.propTypes = {
  preventiveTask: PropTypes.instanceOf(Object).isRequired,
  dispatchPutDeactivatePreventiveTaskResource: PropTypes.func.isRequired,
  dispatchGetPreventiveTask: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutDeactivatePreventiveTaskResource:
    putDeactivatePreventiveTaskResource,
  dispatchGetPreventiveTask: getPreventiveTask,
};

export default connect(
  null,
  mapDispatchToProps,
)(EndPreventiveTaskResourceButton);
